import cns from 'classnames';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { OverlayTrigger, Popover, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { RuntimeContext } from '../../../../../common/RuntimeContext';
import Image from '../../../../shared/components/Image';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../shared/components/VerbButton';
import VerbDropdownButton from '../../../../shared/components/VerbDropdownButton';
import { CREATED_BY_TYPES, DEFAULT_IMAGE_URLS, LEARNING_ASSET_TYPES } from '../../../../shared/Constants';
import copyIdToClipboard from '../../../../shared/utils/AdminUtils';

export default class LearningAssetTableRow extends Component {
    static propTypes = {
        learningAsset: PropTypes.object,
        updateLearningAssetArchiveStatus: PropTypes.func,
        getLearningAssetStatus: PropTypes.func,
        isContentAdmin: PropTypes.bool,
        isVerbAdmin: PropTypes.bool,
        history: PropTypes.object,
        isWelcomeAssetTable: PropTypes.bool,
        cloneLearningAsset: PropTypes.func,
        isGlobalSectionItemUsageTable: PropTypes.bool,
        hideCreatedByAndAuthorColumns: PropTypes.bool
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);

        this.state = {
            learningAssetsStatusById: {}
        };
    }

    _renderAssociatedCollections = (learningAsset) => {
        const collectionNames = [];
        (learningAsset.collections || []).forEach((collection, index) => {
            if (collection.name) {
                let collectionName = collection.name;
                if (index < learningAsset.collections.length - 1) {
                    collectionName += ', ';
                }
                collectionNames.push(
                    <a key={`${collection._id}-${learningAsset._id}`} href={`/paths/editcollection/${collection._id}`}>
                        {collectionName}
                    </a>
                );
            }
        });
        return collectionNames;
    };

    _makeArchiveSubmissionPopover = (learningAsset, learningAssetsStatusById) => {
        const currentLearningAssetStatus = learningAssetsStatusById[learningAsset._id];
        let archiveSubmissionMessage;
        let associateCollectionsMessage = null;
        let licenscedCompaniesMessage = null;
        let confirmButton = null;

        if (!isEmpty(currentLearningAssetStatus)) {
            if (currentLearningAssetStatus.isInCollection === true) {
                archiveSubmissionMessage = (
                    <p
                        className={'archive-status-message not-ready'}
                    >{`${learningAsset.name} is not ready to be archived!`}</p>
                );
                associateCollectionsMessage = (
                    <div className={'associate-entity-container'}>
                        <Row>
                            <p className={'associated-entity'}>Associated collections:</p>
                        </Row>
                        {currentLearningAssetStatus.associatedCollections.map((collection) => (
                            <Row key={`${learningAsset._id}-${collection._id}`}>
                                <p className={'collection-name'} key={`${learningAsset._id}-${collection.name}`}>
                                    - {collection.name}
                                </p>
                            </Row>
                        ))}
                    </div>
                );
            }

            if (currentLearningAssetStatus.isLicensedByCompany === true) {
                archiveSubmissionMessage = (
                    <p
                        className={'archive-status-message not-ready'}
                    >{`${learningAsset.name} is not ready to be archived!`}</p>
                );
                licenscedCompaniesMessage = (
                    <div className={'associate-entity-container'}>
                        <Row>
                            <p className={'associated-entity'}>Licensed companies:</p>
                        </Row>
                        {currentLearningAssetStatus.licensedCompanies.map((company) => (
                            <Row key={`${learningAsset._id}-${company._id}`}>
                                <p className={'company-name'} key={`${learningAsset._id}-${company.name}`}>
                                    - {company.name}
                                </p>
                            </Row>
                        ))}
                    </div>
                );
            }

            if (
                currentLearningAssetStatus.isInCollection === false &&
                currentLearningAssetStatus.isLicensedByCompany === false
            ) {
                archiveSubmissionMessage = (
                    <p className={'archive-status-message'}>{`${learningAsset.name} is ready to be archived!`}</p>
                );
                confirmButton = (
                    <VerbButton
                        fontAwesomeIcon={'fa-save'}
                        className={'archive-submit-button'}
                        onClick={() =>
                            this.props.updateLearningAssetArchiveStatus({
                                learningAsset,
                                isArchived: !learningAsset.isArchived
                            })
                        }
                    >
                        ARCHIVE ACTIVITY
                    </VerbButton>
                );
            }
        }

        return (
            <Popover id={'archive-submission-popover'} className={'archive-submission-popover'}>
                {archiveSubmissionMessage}
                {associateCollectionsMessage}
                {licenscedCompaniesMessage}
                <div className={'content-submission-buttons-container'}>{confirmButton}</div>
            </Popover>
        );
    };

    _renderActionButtons = (learningAsset) => {
        const {
            getLearningAssetStatus,
            isContentAdmin,
            isVerbAdmin,
            history,
            isWelcomeAssetTable,
            isGlobalSectionItemUsageTable
        } = this.props;
        const { learningAssetsStatusById } = this.state;
        const archiveSubmissionPopover = this._makeArchiveSubmissionPopover(learningAsset, learningAssetsStatusById);

        const previewButton = (
            <VerbButton
                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                newTab={true}
                fontAwesomeIcon={'fa-eye'}
                href={`/previewlearningasset/${learningAsset.type === 'WELCOME' ? 'welcome' : 'learning'}/${
                    learningAsset._id
                }`}
            />
        );

        const archiveButton = (
            <OverlayTrigger
                trigger={'click'}
                placement={'bottom'}
                rootClose
                transition={false}
                overlay={archiveSubmissionPopover}
            >
                <VerbButton
                    className={'archive-button'}
                    buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                    fontAwesomeIcon={'fa-archive'}
                    onClick={(e) => {
                        e.stopPropagation();
                        getLearningAssetStatus(learningAsset._id, { pathsContext: this.context.pathsWeb }).then(
                            (learningAssetStatus) => {
                                this.setState({
                                    learningAssetsStatusById: {
                                        ...this.state.learningAssetsStatusById,
                                        [learningAsset._id]: learningAssetStatus
                                    }
                                });
                            }
                        );
                    }}
                />
            </OverlayTrigger>
        );

        const copyAssetButton = (
            <VerbButton
                buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                fontAwesomeIcon={'fal fa-clone'}
                onClick={() => {
                    this.props.cloneLearningAsset(learningAsset);
                }}
            />
        );

        const dropdownData = [
            {
                text: 'COPY ACTIVITY',
                fontAwesomeIcon: 'fa-clone',
                fontAwesomeIconWeight: 'fal',
                onClick: () => {
                    this.props.cloneLearningAsset(learningAsset);
                }
            },
            {
                text: 'COPY ID',
                fontAwesomeIcon: 'fa-clipboard',
                fontAwesomeIconWeight: 'fal',
                onClick: () => {
                    copyIdToClipboard(learningAsset._id);
                }
            }
        ];

        const path = learningAsset.type === 'WELCOME' ? 'welcome' : 'learning';
        const style = {
            minWidth: isWelcomeAssetTable || isGlobalSectionItemUsageTable ? '60px' : '150px'
        };

        return (
            <td style={style}>
                <VerbButton
                    buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                    fontAwesomeIcon={'fa-pencil'}
                    onClick={
                        !isGlobalSectionItemUsageTable
                            ? () => history.push(`/edit${path}asset/${learningAsset._id}/summary`)
                            : () => {}
                    }
                    href={isGlobalSectionItemUsageTable ? `/edit${path}asset/${learningAsset._id}/summary` : null}
                    newTab={isGlobalSectionItemUsageTable}
                />
                {learningAsset.type !== LEARNING_ASSET_TYPES.FEEDBACK && previewButton}
                {isWelcomeAssetTable && copyAssetButton}
                {(isContentAdmin || isVerbAdmin) &&
                    !isWelcomeAssetTable &&
                    !isGlobalSectionItemUsageTable &&
                    archiveButton}
                {!isWelcomeAssetTable && !isGlobalSectionItemUsageTable && (
                    <VerbDropdownButton
                        fontAwesomeIcon={'fa-ellipsis-h'}
                        dropdownData={dropdownData}
                        className={'manage-learning-assets-popover'}
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                    />
                )}
            </td>
        );
    };

    _getAssetCreatedBy = (learningAsset) => {
        let createdByText;

        if (learningAsset.createdBy === CREATED_BY_TYPES.BY_VERB) {
            createdByText = 'Verb';
        } else if (learningAsset.createdBy === CREATED_BY_TYPES.BY_THIRD_PARTY) {
            createdByText = 'Third-party';
        } else {
            createdByText = (learningAsset.author || {}).companyName || '';
        }

        return <td>{createdByText}</td>;
    };

    render() {
        const { learningAsset, isWelcomeAssetTable, isGlobalSectionItemUsageTable, hideCreatedByAndAuthorColumns } = this.props;
        let authorName = null;
        if (learningAsset.author) {
            if (typeof learningAsset.author === 'object') {
                authorName = `${learningAsset.author.firstName} ${learningAsset.author.lastName}`;
            } else {
                authorName = learningAsset.author;
            }
        }
        let activityType = learningAsset.type || '';
        if (activityType === 'ACTIVITY') {
            activityType = 'INTERACTIVE';
        }
        return (
            <tr className={cns('learning-asset-table-row')}>
                {this._renderActionButtons(learningAsset)}
                <td style={{ minWidth: '300px' }}>
                    <Image
                        key={`${learningAsset._id}-image`}
                        src={learningAsset.thumbnailImageUrl || DEFAULT_IMAGE_URLS.LEARNING_ASSET_THUMBNAIL_IMAGE}
                        className={'trackCoverImage'}
                        dimension={{ h: 100, w: 100 }}
                        style={{ width: '50px', height: '50px' }}
                        alt={'trackCoverImage'}
                    />
                    <Link to={`/review/learningasset/${learningAsset._id}`}>{learningAsset.name}</Link>
                </td>
                {!isWelcomeAssetTable && !isGlobalSectionItemUsageTable && (
                    <td>{this._renderAssociatedCollections(learningAsset)}</td>
                )}
                <td>{activityType}</td>
                {!isWelcomeAssetTable && !hideCreatedByAndAuthorColumns ? this._getAssetCreatedBy(learningAsset) : null}
                {!hideCreatedByAndAuthorColumns ? <td>{authorName}</td> : null}
                <td>{moment(learningAsset.updatedOn).format('MMM Do YYYY')}</td>
                <td>{learningAsset.isActive ? <i className={'fal fa-check-circle'} /> : null}</td>
                {isWelcomeAssetTable || isGlobalSectionItemUsageTable ? null : (
                    <td>
                        {(learningAsset.comments && learningAsset.comments.length) || learningAsset.comments > 0 ? (
                            <i className={'fal fa-comment color-pink'} />
                        ) : null}
                    </td>
                )}
            </tr>
        );
    }
}
